import { render, staticRenderFns } from "./ReviewMemberSettingsController.vue?vue&type=template&id=62cda0d0&"
import script from "./ReviewMemberSettingsController.vue?vue&type=script&lang=js&"
export * from "./ReviewMemberSettingsController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports